/**
 * Pachetul "Se joaca bine impreuna" de pe pagina de produs.
 * Ia recomandarile din API-ul Shopify, le afiseaza cu bife si adauga tot cu un singur click.
 * Produsul de baza e mereu inclus si nu se poate debifa.
 */
(function () {
  'use strict';

  var root = document.querySelector('[id^="br-bundle-"]');
  if (!root) return;

  var sectionId = root.id.replace('br-bundle-', '');
  var itemsEl = document.getElementById('br-bundle-items-' + sectionId);
  var totalEl = document.getElementById('br-bundle-total-' + sectionId);
  var addBtn = document.getElementById('br-bundle-add-' + sectionId);
  var productId = root.getAttribute('data-product-id');

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function fetchRecs(intent) {
    return fetch('/recommendations/products.json?product_id=' + productId +
                 '&limit=3&intent=' + intent)
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.products) || []; });
  }


  /** Taie titlul lung la prima liniuta sau bara, dar nu si intre cifre (ex. 0-6 Luni). */
  function numeScurt(titlu) {
    var t = String(titlu);
    var re = /[–—|,]|\s-\s/g;
    var m;
    while ((m = re.exec(t)) !== null) {
      if (m.index < 10) continue;
      var inainte = t.slice(Math.max(0, m.index - 2), m.index).trim().slice(-1);
      var dupa = t.slice(m.index + m[0].length, m.index + m[0].length + 2).trim().slice(0, 1);
      if (/\d/.test(inainte) && /\d/.test(dupa)) continue;
      t = t.slice(0, m.index);
      break;
    }
    t = t.replace(/[\s\-–—|,]+$/, '');
    if (t.length > 42) {
      var out = [];
      t.split(' ').forEach(function (w) {
        if (out.join(' ').length + w.length + 1 <= 42) out.push(w);
      });
      t = out.join(' ');
    }
    return t.replace(/\s+(cu|pentru|si|și|de|din|la)$/i, '');
  }

  /**
   * Primele doua recomandari intra bifate, a treia nu.
   * Cu toate trei bifate, totalul median al pachetului iese 270 lei si un sfert
   * din pachete trec de 400, mult peste zona in care cumpara clientii BabyRio
   * (AOV 187, comenzi cu mai multe produse 240). Cu doua, medianul e 179.
   */
  /* BR 2026-09-01: featured_image vine de la /products/xxx.js la marime ORIGINALA.
     Miniatura se randeaza la 56x65 px, deci la DPR 1,75 are nevoie de ~98px, dar se
     descarcau 179 KB. Cerem CDN-ului Shopify o varianta mica. */
  function mic(url, w) {
    if (!url) return url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function card(p, i) {
    var v = p.variants && p.variants[0];
    if (!v) return '';
    return (
      '<label class="br-bundle__item" data-variant="' + v.id + '" data-price="' + v.price + '">' +
        '<input type="checkbox" class="br-bundle__check"' + (i < 2 ? ' checked' : '') + '>' +
        '<span class="br-bundle__thumb">' +
          (p.featured_image ? '<img src="' + mic(p.featured_image, 160) + '" alt="" loading="lazy" width="80" height="80">' : '') +
        '</span>' +
        '<span class="br-bundle__name">' + numeScurt(p.title) + '</span>' +
        '<span class="br-bundle__price">+' + money(v.price) + '</span>' +
      '</label>'
    );
  }

  function recalc() {
    // totalul include produsul de pe pagina, pentru ca butonul il adauga si pe el
    var total = Number(root.getAttribute('data-base-price'));
    itemsEl.querySelectorAll('.br-bundle__item').forEach(function (el) {
      if (el.querySelector('.br-bundle__check').checked) {
        total += Number(el.getAttribute('data-price'));
      }
    });
    totalEl.textContent = money(total);
  }

  function render(products) {
    if (!products.length) return;
    itemsEl.innerHTML = products.map(function (p, i) { return card(p, i); }).join('');
    root.hidden = false;
    recalc();
    itemsEl.addEventListener('change', recalc);
  }

  addBtn.addEventListener('click', function () {
    // produsul de pe pagina intra mereu in cos, plus ce a bifat clientul
    var items = [{ id: Number(root.getAttribute('data-base-variant')), quantity: 1 }];
    itemsEl.querySelectorAll('.br-bundle__item').forEach(function (el) {
      if (el.querySelector('.br-bundle__check').checked) {
        items.push({ id: Number(el.getAttribute('data-variant')), quantity: 1 });
      }
    });
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
        addBtn.textContent = 'Nu s-a putut adăuga. Încearcă din nou.';
      });
  });

  fetchRecs('complementary')
    .then(function (list) { return list.length ? list : fetchRecs('related'); })
    .then(render)
    .catch(function () { /* fara recomandari, blocul ramane ascuns */ });
})();
